export class ApplicationWorkflowIdentifiers {
  applicationId: string;
  workflowId: string;
  workflowVersionId: string;
}
